module.exports = __webpack_public_path__ + "static/media/0031.bfbb767e.svg";